import "./ContactBanner.css";

export default function ContactBanner() {
  return (
    <div className="container-fluid" style={{backgroundColor:'#f7f0d3'}}>
   <section className="ayb-wrapper d-flex align-items-center">
  <div className="container" style={{color:'wheat'}}>
           <h1 className="ayb-heading head-font">
          Experience How You Heal Traditionally with Ayur Moksha
        </h1>

        <p className="para-font">
         At Ayur Moksha, healing is a return to balance through authentic Ayurvedic principles. Our traditional therapies, personalized care, and mindful approach support vitality, immunity, and inner calm.
          In a serene, nurturing setting, each experience helps you slow down, reconnect, and heal the traditional way.
        </p>
   </div>
</section>
<div className="container mt-5 mb-5">
    <div className="row">
         <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3914.1287351248693!2d75.82224127452201!3d11.178102951657358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba651c7a56ba843%3A0x31a3103ab58b2c2c!2sAyur%20Moksha!5e0!3m2!1sen!2sin!4v1768467045015!5m2!1sen!2sin" width="100%" height="350" style={{Border:'3px solid black'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
<br/>
<br/>
</div>
</div>
  );
}
